export default __webpack_public_path__ + "6bd4e9473082b2256964a67537e9690a.otf";